import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import {
  Wrapper,
  PageContent,
  Title,
  Subtitle,
  SubtitlePlaceholder,
  LeftFields,
  Input,
  CountryCityWrapper,
  SelectWrapper,
  RightFields,
  Button,
  ButtonPlaceholder,
  Text,
  Anchor,
  Spinner,
} from './SignUpPage.style';

import Placeholder from '../../../components/Placeholder';

const image = {
  title: 'Seminar Photo Gallery',
  description: 'Seminar Photo Gallery',
  file: {
    url:
      'https://images.ctfassets.net/qf666eyypqhw/1qanwtJ3SEuKSuiiKkIaYQ/a1f2dcc94b1ee96288c60e58dac36b19/pattern.jpg',
    details: { size: 3813, image: { width: 900, height: 1024 } },
    fileName: 'stylist_tool_login_pattern.jpg',
    contentType: 'image/jpeg',
  },
};

const SignUpForm2 = ({
  copy,
  givenName,
  familyName,
  country,
  city,
  jobTitle,
  yearsExperience,
  locale,
  password,
  passwordMatch,
  email,
  onInputChange,
  onSignUp,
  isValidSignUpForm,
  loading,
  error,
}) => (
  <Wrapper bg={image.file.url} w={image.file.details.image.width}>
    <PageContent>
      {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
        <Title>{copy.sign_up_2}</Title>
      ) : (
        <div>
          <Placeholder h="40px" w="500px" />
        </div>
      )}
      {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
        <Subtitle>{copy.sign_up_2_instructions}</Subtitle>
      ) : (
        <SubtitlePlaceholder>
          <Placeholder h="24px" w="400px" />
        </SubtitlePlaceholder>
      )}
      <form onSubmit={onSignUp}>
        <LeftFields>
          <Input
            type="text"
            placeholder={copy.given_name_placeholder}
            value={givenName}
            onChange={onInputChange('givenName')}
          />
          <Input
            type="text"
            placeholder={copy.family_name_placeholder}
            value={familyName}
            onChange={onInputChange('familyName')}
          />
          <CountryCityWrapper>
            <SelectWrapper>
              <select onChange={onInputChange('country')} value={country || 'Country'}>
                <option value="Country" disabled>
                  {copy.country}
                </option>
                <option value="Japan">{copy.japan}</option>
                <option value="Taiwan">{copy.taiwan}</option>
                <option value="Hong Kong">{copy.hongKong}</option>
                <option value="Indonesia">{copy.indonesia}</option>
                <option value="Malaysia">{copy.malaysia}</option>
                <option value="Korea">{copy.korea}</option>
                <option value="Thailand">{copy.thailand}</option>
                <option value="Singapore">{copy.singapore}</option>
                <option value="China">{copy.china}</option>
              </select>
            </SelectWrapper>
            <Input type="text" placeholder={copy.city_placeholder} value={city} onChange={onInputChange('city')} />
          </CountryCityWrapper>

          <Input
            type="text"
            placeholder={copy.job_title_placeholder}
            value={jobTitle}
            onChange={onInputChange('jobTitle')}
          />
          <Input
            type="text"
            placeholder={copy.years_experience_placeholder}
            value={yearsExperience}
            onChange={onInputChange('yearsExperience')}
          />
        </LeftFields>
        <RightFields>
          <Input type="email" placeholder={copy.email_placeholder} value={email} onChange={onInputChange('email')} />
          <Input
            type="password"
            placeholder={copy.password_placeholder}
            value={password}
            onChange={onInputChange('password')}
          />
          <Input
            type="password"
            placeholder={copy.passwordMatch_placeholder}
            value={passwordMatch}
            onChange={onInputChange('passwordMatch')}
          />
          {error && <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>}
          {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
            <Button
              type="submit"
              disabled={!isValidSignUpForm() || loading}
              style={{ maxWidth: '300px', width: '100%' }}
            >
              {loading ? <Spinner /> : copy.sign_up}
            </Button>
          ) : (
            <ButtonPlaceholder>
              <Placeholder h="65px" w="300px" />
            </ButtonPlaceholder>
          )}
          {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
            <Text>
              {copy.already_have_account}
              <Link to={`/${locale}/stylist/login`} href={`/${locale}/stylist/login`}>
                <Anchor>{copy.sign_in}</Anchor>
              </Link>
            </Text>
          ) : (
            <div>
              <Placeholder h="25px" w="250px" />
            </div>
          )}
        </RightFields>
      </form>
    </PageContent>
  </Wrapper>
);

SignUpForm2.defaultProps = {
  copy: {},
  loading: false,
  error: '',
};

SignUpForm2.propTypes = {
  copy: PropTypes.shape({}),
  givenName: PropTypes.string.isRequired,
  familyName: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  yearsExperience: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  passwordMatch: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onSignUp: PropTypes.func.isRequired,
  isValidSignUpForm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

export default SignUpForm2;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/SignUpPage/SignUpForm2.js